'use client';

import { useSyncExternalStore } from 'react';

let currentTime = Date.now();
const listeners = new Set<() => void>();
let intervalId: ReturnType<typeof setInterval> | null = null;

function startTimer() {
  if (intervalId === null && listeners.size > 0) {
    intervalId = setInterval(() => {
      currentTime = Date.now();
      listeners.forEach((listener) => listener());
    }, 1000);
  }
}

function stopTimer() {
  if (intervalId !== null && listeners.size === 0) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

function subscribe(listener: () => void) {
  currentTime = Date.now();
  listeners.add(listener);
  startTimer();
  return () => {
    listeners.delete(listener);
    stopTimer();
  };
}

function getSnapshot() {
  return currentTime;
}

export function useCurrentTime(): number {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
